module.exports = __webpack_public_path__ + "static/media/google_play.c44f4729.png";